import { ReactNode, useEffect, useState } from 'react'
import { ArrowUp } from 'lucide-react'
import Header from './Header'
import Footer from './Footer'
import { useSiteTracking } from '../../lib/useTracking'

// دکمه بازگشت به بالا — بعد از کمی اسکرول ظاهر می‌شود
const BackToTop = () => {
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 600)
    onScroll()
    window.addEventListener('scroll', onScroll, { passive: true })
    return () => window.removeEventListener('scroll', onScroll)
  }, [])

  return (
    <button
      onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
      aria-label="بازگشت به بالا"
      className={`fixed bottom-6 left-6 z-40 h-11 w-11 rounded-full bg-primary-500 text-white shadow-lg flex items-center justify-center transition-all duration-300 hover:bg-primary-600 ${
        visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4 pointer-events-none'
      }`}
    >
      <ArrowUp className="h-5 w-5" />
    </button>
  )
}

const Layout = ({ children }: { children: ReactNode }) => {
  // ردیابی بازدید (نبض هر ۱۵ ثانیه) — فقط برای صفحات عمومی سایت
  useSiteTracking()

  return (
    <div className="relative min-h-screen flex flex-col">
      <Header />
      <main className="flex-1">{children}</main>
      <Footer />
      <BackToTop />
    </div>
  )
}

export default Layout
